import React from 'react';

const ResourcesIcon = ({
  backgroundFill,
  outerStrokeColor,
  innerStrokeColor,
  strokeWidth,
  width,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 24 24"
      fill={backgroundFill}
      strokeWidth={strokeWidth}
      width={width}
    >
      <circle cx="12" cy="12" r="10.5" stroke={outerStrokeColor} />
      <line
        x1="12"
        y1="10.9"
        x2="12"
        y2="16.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={innerStrokeColor}
      />
      <circle cx="12" cy="7.5" r="1.1" fill={innerStrokeColor} stroke="none" />
    </svg>
  );
};

export default ResourcesIcon;
